<template>
  <div class="video-gallery-card" :class="{ editable: galleryItem.id != 0 }">
    <likeButton
      v-if="managerMode != 'dataEdit'"
      :likeNumber="galleryItem.like"
    ></likeButton>
    <div class="cover-box image-loading">
      <img
        class="video-cover-img"
        :src="
          galleryItem.id == 0
            ? getImgUrl(galleryItem.cover)
            : galleryItem.cover
            ? galleryItem.cover
            : getImgUrl('img/cover_video.png')
        "
        alt=""
      />
      <p v-if="galleryItem.title" class="title">
        {{ galleryItem.title }}
      </p>
      <img
        v-if="managerMode != 'dataEdit'"
        src="@/assets/img/public/video_play.svg"
        alt="video-play"
        class="video-play"
      />
    </div>
    <p v-if="galleryItem?.description" class="description">
      {{ galleryItem?.description }}
    </p>
    <editBox
      :option="['edit', 'remove']"
      :item="'videoGallery'"
      :itemId="galleryItem.id"
      displayMode="horizontal_center"
      v-if="galleryItem.id != 0"
    />
  </div>
</template>

<script>
import likeButton from "@/components/likeButton/index.vue";
import { publicHelpers } from "@/public/helpers";
import { mapGetters } from "vuex";
import editBox from "@/components/editBox/index.vue";
export default {
  name: "galleryVideoCard",
  mixins: [publicHelpers],
  components: {
    likeButton,
    editBox,
  },
  props: {
    galleryItem: Object,
  },
  computed: {
    ...mapGetters({
      managerMode: "managerMode",
    }),
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/galleryVideoCard/galleryVideoCard.css);
</style>